"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('brain', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M19.036 44C18.0561 40.8044 16.5778 38.422 14.6011 36.8531C11.636 34.4996 6.92483 35.9623 5.18458 33.5347C3.44433 31.1072 6.40382 26.6429 7.44234 24.0089C8.48086 21.3748 3.46179 20.4434 4.04776 19.6957C4.43842 19.1971 6.97471 17.7586 11.6567 15.38C12.987 7.79332 17.9008 4 26.3982 4C39.1441 4 44 14.8059 44 21.6789C44 28.5518 38.1201 35.9562 29.7441 37.5527C28.9951 38.6434 30.0754 40.7926 32.9848 44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 14.4998C18.8466 17.0341 19.041 18.8136 20.0831 19.8384C21.1252 20.8631 22.9013 21.5332 25.4115 21.8487C24.842 25.1175 25.5363 26.651 27.4945 26.4492C29.4526 26.2474 30.6292 25.4337 31.0242 24.0082C34.0844 24.8683 35.743 24.1484 36 21.8487C36.3854 18.3991 34.5252 15.6474 33.7626 15.6474C33 15.6474 31.0242 15.5546 31.0242 14.4998C31.0242 13.4451 28.7162 12.8492 26.6332 12.8492C24.5502 12.8492 25.8038 11.4451 22.9434 11.9998C21.0365 12.3696 19.8887 13.203 19.5 14.4998Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M30.5 25.5C29.483 26.131 28.0875 27.1803 27.5 28C26.031 30.0495 24.8395 31.2973 24.5789 32.608",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;